import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../store/index';
import { apiGetMineInfo, apiGetPage, apiGetCustom, apiGetApplicationDetail } from '../request/api'
import { imageUrl, zeusApp } from '../request/index'
import { LogoutOutlined, SwapRightOutlined } from '@ant-design/icons';
import '../assets/css/header.css'

interface OrderItem {
    name: string;
    url: string;
}

interface ApiPageRow {
    mainLand: string;
    siteName: string;
    siteLanguage: string;
    siteCode: string;
}

interface TransformedLanguageList {
    areaName: string;
    items: {
        name: string;
        siteCode: string;
        languageList: { label: string; value: string }[];
        isClose: boolean;
    }[];
}


const Header: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const logoImage = localStorage.getItem('logoImage')
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const [isLanguageVisible, setIsLanguageVisible] = useState<boolean>(false);
    const [hoverIndex, setHoverIndex] = useState<number | null>(null);
    const dispatch = useDispatch();
    const [hoveredIndex, setHoveredIndex] = useState<{ regionIndex: number | null, countryIndex: number | null }>({
        regionIndex: null,
        countryIndex: null
    });
    const [transformedList, setTransformedList] = useState<TransformedLanguageList[]>([]);
    const [loginState, setLoginState] = useState(0)
    const [isLanguageHover, setIsLanguageHover] = useState<boolean>(false);
    const [isUserHover, setIsUserHover] = useState<boolean>(false);
    const [isUserIconHovered, setIsUserIconHovered] = useState(false);
    const [navList, setNavList] = useState<OrderItem[]>([])
    const intervalRef = React.useRef<NodeJS.Timeout | null>(null);
    const [selectedLanguageDisplay, setSelectedLanguageDisplay] = useState<string>('**-**');
    const languageCode = localStorage.getItem('siteLanguage') || 'zh';
    const [hoveredLanguageItem, setHoveredLanguageItem] = useState<{
        regionIndex: number | null;
        countryIndex: number | null;
        itemIndex: number | null;
    }>({
        regionIndex: null,
        countryIndex: null,
        itemIndex: null
    });

    useEffect(() => {
        fetchUserInfo();
        apiGetApplicationDetail('APPLICATION_LOGO').then(res => {
            localStorage.setItem('logoImage', res.data.data)
        })
        apiGetApplicationDetail('APPLICATION_ICON').then(res => {
            console.log(res)
            localStorage.setItem('iconImage', res.data.data)
            console.log(localStorage.getItem('iconImage'))
            const icon = localStorage.getItem('iconImage')
            const faviconUrl = `${imageUrl}${icon}?zeus-app=${zeusApp}`;
            let link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");
            if (!link) {
                link = document.createElement("link");
                link.rel = "icon";
                document.head.appendChild(link);
            }
            link.href = faviconUrl;
        })
        
        apiGetPage({
            tid: '0A2EDC7623D14736828579C3BA07A038',
            search: '',
            page: 1,
            size: 100,
            languagecode: languageCode,
            sort: '',
        }).then(res => {
            const rows: ApiPageRow[] = res.data.data.rows;
            const grouped: { [key: string]: { name: string; languageList: { label: string; value: string }[] }[] } = {};
            rows.forEach(row => {
                const languageList = row.siteLanguage.split(',').map(item => {
                    const [label, value] = item.split(':');
                    return { label, value };
                });

                if (!grouped[row.mainLand]) {
                    grouped[row.mainLand] = [];
                }

                grouped[row.mainLand].push({
                    name: row.siteName,
                    languageList,
                });
            });
            const storedLang = localStorage.getItem('siteLanguage') || 'zh';
            const storedSiteCode = localStorage.getItem('siteCode') || 'SG';
            setSelectedLanguageDisplay(`${storedSiteCode}-${storedLang}`);
            const transformed: TransformedLanguageList[] = Object.entries(grouped).map(([areaName, items]) => ({
                areaName,
                items: items.map((item, idx) => ({
                    name: item.name,
                    siteCode: rows.find(row => row.siteName === item.name)?.siteCode || 'UNKNOWN', // ✅ 从原始数据中找 siteCode
                    languageList: item.languageList, // ✅ 保留完整 label + value
                    isClose: true
                }))
            }));

            setTransformedList(transformed);
        });
        // 获取导航栏数据
        apiGetCustom({
            pageId: '310ED453D3B244909CBD0E8EFE4BF0FA',
            // languageCode: 'zh',
            languageCode: languageCode
        }).then(res => {
            // 定义排序顺序
            const order = ['index', 'service', 'news', 'about', 'contact'];

            // 修正过滤条件：根据 code 排除 pageURL 和 pageTitle
            const sortedNavList = res.data.data
                .filter((item: { code: string; }) =>
                    item.code !== 'pageURL' &&
                    item.code !== 'pageTitle'
                )
                .sort((a: { code: string; }, b: { code: string; }) => {
                    const aIndex = order.indexOf(a.code);
                    const bIndex = order.indexOf(b.code);

                    // 确保在排序列表中的项优先
                    if (aIndex >= 0 && bIndex >= 0) return aIndex - bIndex;
                    if (aIndex >= 0) return -1;
                    if (bIndex >= 0) return 1;

                    // 不在排序列表中的项按原始顺序
                    return 0;
                })
                .map((item: { name: any; value: any; }) => ({
                    name: item.value,
                    url: item.name
                }));

            setNavList(sortedNavList);
        });

        // 设置循环定时器，每隔一段时间获取用户信息
        intervalRef.current = setInterval(() => {
            fetchUserInfo();
        }, 60000); // 每 60 秒执行一次

        // 清理定时器，避免组件卸载时内存泄漏
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [dispatch]);



    const fetchUserInfo = () => {
        apiGetMineInfo().then(res => {
            if (res.data.data !== null) {
                setLoginState(1); // 如果 token 有效，设置登录状态
            } else {
                setLoginState(0); // 如果 token 无效，设置未登录状态
            }
        }).catch(err => {
            console.error('Error fetching user info:', err);
            setLoginState(0); // 请求失败时，也设置为未登录状态
        });
    };

    const handleMouseEnter = (index: number) => {
        setHoverIndex(index);
    };

    const handleMouseLeave = () => {
        setHoverIndex(null);
    };

    const handleNavigation = (path: string) => {
        navigate(path, { state: { resetView: true } });
    };

    const toMine = () => {
        if (loginState) {
            navigate('/mine'); // 如果有 token，导航到 /mine
        } else {
            navigate('/login'); // 如果没有 token，导航到 /login
        }
    }

    const showLanguage = () => {
        setIsLanguageVisible(!isLanguageVisible);
    }

    return (
        <div className="ezheader">
            <div className='ezheader-inner'>
                <div className='ezheader-padding'>
                    <div className='header_image' onClick={() => { navigate('/index'); setIsLanguageVisible(false) }}>
                        <span></span>
                        <img src={`${imageUrl}${logoImage}?zeus-app=${zeusApp}`} />
                    </div>
                    <div className='header_nav'>
                        {navList.map((item, index) => (
                            <div className="nav_item"
                                key={index}
                                onClick={() => { setIsLanguageVisible(false); handleNavigation(item.url) }}
                                onMouseEnter={() => handleMouseEnter(index)}
                                onMouseLeave={handleMouseLeave}
                                style={{
                                    color: location.pathname === item.url || hoverIndex === index ? themeColor : 'inherit',
                                    cursor: 'pointer',
                                    fontSize: languageCode === 'zh' ? '16px' : '18px',
                                }}
                            >
                                {item.name}
                            </div>
                        ))}
                    </div>
                    <div className='header_right'>
                        <div
                            className='header_language'
                            onClick={() => showLanguage()}
                        >
                            <i className="iconfont icon-international"
                                onMouseEnter={() => setIsLanguageHover(true)}
                                onMouseLeave={() => setIsLanguageHover(false)}
                                style={{ color: isLanguageVisible || isLanguageHover ? themeColor : 'inherit', fontSize: '22px' }}
                            />
                        </div>
                        <div
                            className='header_language_txt'
                            onMouseEnter={() => setIsLanguageHover(true)}
                            onMouseLeave={() => setIsLanguageHover(false)}
                            onClick={() => showLanguage()}
                            style={{ color: isLanguageVisible || isLanguageHover ? themeColor : 'inherit' }}
                        >
                            {selectedLanguageDisplay}
                        </div>
                        <div className="header_language_right"
                            style={{
                                fontSize: "22px",
                                color: isUserIconHovered ? themeColor : 'inherit',
                                cursor: 'pointer'
                            }}>
                            <i
                                className="iconfont icon-User"
                                onClick={() => {
                                    toMine();
                                    setIsLanguageVisible(false);
                                }}
                                style={{ fontSize: '22px' }}
                                onMouseEnter={() => {
                                    setIsUserIconHovered(true);
                                    setIsUserHover(false); // 重置hover状态
                                }}
                                onMouseLeave={() => {
                                    if (!isUserHover) {
                                        setIsUserIconHovered(false);
                                    }
                                }}
                            />
                            {loginState == 1 &&
                                <div className="loginOut"
                                    onMouseEnter={() => {
                                        setIsUserHover(true);
                                        setIsUserIconHovered(true); // 保持父级hover状态
                                    }}
                                    onMouseLeave={() => {
                                        setIsUserHover(false);
                                        setIsUserIconHovered(false);
                                    }}
                                    style={{
                                        color: isUserHover ? themeColor : '#000',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '5px',
                                        fontSize: '14px',
                                        opacity: isUserIconHovered ? 1 : 0, // 直接控制显隐
                                        visibility: isUserIconHovered ? 'visible' : 'hidden',
                                        transform: isUserIconHovered ? 'translateY(0)' : 'translateY(-10px)'
                                    }}
                                    onClick={() => { handleNavigation("/login") }}>
                                    <LogoutOutlined />
                                    <span>{languageCode === 'zh' ? '退出登录' : 'Logout'}</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                {isLanguageVisible &&
                    <div className='language'>
                        <div className='contury_body_item'>
                            {transformedList.map((area, regionIndex) => (
                                <div key={regionIndex} className="language_item">
                                    <div className='language_header'>{area.areaName}</div>
                                    {area.items.map((country, countryIndex) => (
                                        <div
                                            className='contury_item'
                                            key={countryIndex}
                                            onMouseEnter={() => setHoveredIndex({ regionIndex, countryIndex })}
                                            onMouseLeave={() => setHoveredIndex({ regionIndex: null, countryIndex: null })}
                                            style={{
                                                backgroundColor:
                                                    hoveredIndex.regionIndex === regionIndex && hoveredIndex.countryIndex === countryIndex
                                                        ? '#f6f6f8'
                                                        : '#ffffff',
                                                transition: 'background-color 0.3s ease'
                                            }}
                                        >
                                            <div className='contury_name'>{country.name}</div>
                                            <div className='contury_body_item'>
                                                {country.languageList.map((lang, langIndex) => (
                                                    <div
                                                        key={langIndex}
                                                        onMouseEnter={() =>
                                                            setHoveredLanguageItem({
                                                                regionIndex,
                                                                countryIndex,
                                                                itemIndex: langIndex,
                                                            })
                                                        }
                                                        onMouseLeave={() =>
                                                            setHoveredLanguageItem({
                                                                regionIndex: null,
                                                                countryIndex: null,
                                                                itemIndex: null,
                                                            })
                                                        }
                                                        onClick={() => {
                                                            const selectedCountry = area.items[countryIndex];
                                                            const selectedLang = selectedCountry.languageList[langIndex]; 

                                                            localStorage.setItem('siteLanguage', selectedLang.value); 
                                                            localStorage.setItem('siteCode', selectedCountry.siteCode); 

                                                            setIsLanguageVisible(false);
                                                            window.location.reload();
                                                        }}
                                                        style={{
                                                            color:
                                                                hoveredLanguageItem.regionIndex === regionIndex &&
                                                                    hoveredLanguageItem.countryIndex === countryIndex &&
                                                                    hoveredLanguageItem.itemIndex === langIndex
                                                                    ? themeColor
                                                                    : '#33364b',
                                                            cursor: 'pointer',
                                                            transition: 'color 0.3s ease',
                                                            padding: '4px 16px 0 0',
                                                        }}
                                                    >
                                                        {lang.label}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ))}

                        </div>
                    </div>
                }
            </div>
            {isLanguageVisible &&
                <div
                    className="language_overlay"
                    onClick={() => { setIsLanguageVisible(false) }} // 点击遮罩层隐藏语言栏
                ></div>
            }

        </div>
    );
};

export default Header;